// ADDED
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ShieldIcon from '@mui/icons-material/Shield';

const MedicalClearanceAccessModal = ({ isOpen, onClose, template, onSave, loading }) => {
  const [selectedRole, setSelectedRole] = useState(""); // "manager", "processor", or ""

  useEffect(() => {
    if (template) {
      if (template.isMedicalClearanceManager) setSelectedRole("manager");
      else if (template.isMedicalClearanceProcessor) setSelectedRole("processor");
      else setSelectedRole("");
    }
  }, [template, isOpen]);

  if (!isOpen) return null;

  const roleOptions = [
    { id: "manager", label: "Clearance Manager", desc: "Can assign requirements to employees." },
    { id: "processor", label: "Clearance Processor", desc: "Can check/complete specific requirements." },
    { id: "", label: "No Access", desc: "Template will have no medical clearance rights." }
  ];

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white w-full max-w-md rounded-lg shadow-2xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50 rounded-t-lg">
          <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <ShieldIcon className="text-blue-600" /> Update Access
          </h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer text-gray-400 hover:text-gray-700">
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div className="p-3 bg-blue-50 border border-blue-100 rounded">
            <p className="text-[10px] uppercase font-bold text-blue-400 m-0">Access Template</p>
            <p className="text-sm font-bold text-blue-900 m-0">{template?.description}</p>
          </div>

          <div className="space-y-3">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-widest">Select Permission Level</p>
            {roleOptions.map((role) => (
              <label 
                key={role.id} 
                className={`flex items-start gap-3 p-3 border rounded-lg cursor-pointer transition-all hover:border-blue-400 
                  ${selectedRole === role.id ? 'bg-blue-50 border-blue-500 ring-1 ring-blue-500' : 'bg-white border-gray-200'}`}
              >
                <input
                  type="radio"
                  name="clearanceRole"
                  className="mt-1 h-4 w-4"
                  checked={selectedRole === role.id}
                  onChange={() => setSelectedRole(role.id)}
                />
                <div>
                  <p className="text-sm font-bold m-0 text-gray-800">{role.label}</p>
                  <p className="text-[10px] text-gray-500 m-0 leading-tight">{role.desc}</p>
                </div>
              </label>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 p-4 border-t bg-gray-50 rounded-b-lg">
          <button onClick={onClose} className="px-6 py-2 bg-gray-300 text-gray-700 rounded border-none cursor-pointer">Cancel</button>
          <button 
            onClick={() => onSave(selectedRole)}
            disabled={loading}
            className="px-8 py-2 bg-blue-600 text-white rounded border-none cursor-pointer font-bold hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicalClearanceAccessModal;